import { Alert } from '@designsforhealth/dfh-react-components'
import {
  Label,
  ProductSelector,
  ProductSelectorOption,
  ProductSelectorOptionProps,
} from '@dfh-corp-sites/ui'
import React, { FC } from 'react'
import { Controller, UseFormMethods } from 'react-hook-form'
import { useId } from 'react-id-generator'

import { formatAsCurrency } from '../../../utils/priceTools'
import { ItemSelectorOptionPaymentTimingPrice } from './ItemSelectorOptionLabel'

export interface PaymentTimingOptionsProps {
  size: ProductSelectorOptionProps['size']
  control: UseFormMethods['control']
  showAlert?: boolean
  payUpfrontPrice: number
  payUpfrontOptionValue: string
}

const PaymentTimingOptions: FC<PaymentTimingOptionsProps> = ({
  size,
  control,
  showAlert,
  payUpfrontPrice,
  payUpfrontOptionValue,
}) => {
  const attribute = 'price'
  const ids = useId(2, `${attribute}-`)
  const labelId = `${attribute}-label`

  return (
    <div className="space-y-3">
      <Label className="font-medium" id={labelId}>
        {attribute}
      </Label>
      <Controller
        control={control}
        name="pay_upfront_option_value"
        render={(field) => (
          <ProductSelector
            name={field.name}
            defaultValue={''}
            onValueChange={field.onChange}
            aria-labelledby={labelId}
          >
            <ProductSelectorOption
              size={size}
              id={ids[0]}
              value={''}
              label={'Pay later'}
              price={<ItemSelectorOptionPaymentTimingPrice price={0} priceAside="Now" />}
            />
            <ProductSelectorOption
              size={size}
              id={ids[1]}
              value={payUpfrontOptionValue}
              label={'Pay upfront'}
              price={<ItemSelectorOptionPaymentTimingPrice price={payUpfrontPrice} />}
            />
          </ProductSelector>
        )}
      />
      {showAlert && (
        <Alert type="attention">
          You will be charged {formatAsCurrency({ amount: payUpfrontPrice })} at the time of
          analyzing and obtaining the results.
        </Alert>
      )}
    </div>
  )
}

export default PaymentTimingOptions
